import { useEffect, useState, useMemo } from "react";
import UserFilters from "../UserFilters.jsx";
import GreenAmbassadorTable from "../GreenAmbassadorTable.jsx";
import { getAllUserList } from "../../../api/users.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Heading from "../../../components/Heading.jsx";
import { useGetUserByUserType, useGetUsers } from "../../../queries/user.js";
import Loader from '../../../components/Common/Loader.jsx';

function UserAmbassadorList() {

    // const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const genderFilters = [
        { value: 'male', placeholder: 'Male', },
        { value: 'female', placeholder: 'Female', },
        { value: 'other', placeholder: 'Other', }
    ];
    const ageGroupFilters = [
        { value: 'kid', placeholder: 'Kid' },
        { value: 'adult', placeholder: 'Adult' },
        { value: 'old', placeholder: 'Old' },
    ];
    const userActiveFilters = [
        { value: true, placeholder: 'Active' },
        { value: false, placeholder: 'Inactive' },
    ];
    const userTypeFilters = [
        { value: 'regular', placeholder: 'Regular' },
        { value: 'ambassador', placeholder: 'Ambassador' },
        { value: 'NGO', placeholder: 'NGO' },
        { value: 'Company', placeholder: 'Company' },
    ];

    const [filters, setFilters] = useState([
        { label: 'Full Name', placeholder: 'Enter Full Name', name: 'name', value: '', type: 'text' },
        { label: 'Username', placeholder: 'Enter Username', name: 'username', value: '', type: 'text' },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', value: '', type: 'email' },
        { label: 'Influencer', placeholder: 'Influencer', data: [{value: true, placeholder: 'Yes'}, {value: false, placeholder: 'No'}], name: 'isInfluencer', value: '', type: 'select' },

    ]);

    const [searchFilters, setSearchFilters] = useState({});

    const activeFiltersObject = useMemo(() => {
        const active = filters.filter(f => f.value !== '');
        const obj = {};
        active.forEach(f => {
            obj[f.name] = f.value;
        });
        return obj;
    }, [filters]);

    const filterUsers = () => {
        setSearchFilters(activeFiltersObject);
    };

    const clearFilters = () => {
        const resetFilters = filters.map(filter => ({ ...filter, value: '' }));
        setFilters(resetFilters);
        setSearchFilters({});
    };

    // const { data: users, isPending, error } = useGetUsers(toast);
    const { data: users, isPending, error } = useGetUserByUserType({ toast, userType: 'ambassador', filters: searchFilters });
    // console.log(error);

    useEffect(() => {
        if (users) {
            setFilteredUsers(users.users || users || []);
            setPagination(users.pagination || null);
        }
    }, [users]);

    if (isPending) {
        return (
            <div className="flex justify-center items-center h-screen">
                <Loader />
            </div>
        );
    }

    if (error) {
        toast.error('Failed to fetch users!');
    }

    return (
        <main className="flex flex-col text-sm font-semibold text-gray-900 rounded-none">
            <Heading
                text={"Ambassador List"}
            />
            <UserFilters
                filters={filters}
                setFilters={setFilters}
                filterUsers={filterUsers}
                clearFilters={clearFilters}
            />
            <section className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-base font-semibold">User/Ambassador Data List</h1>
                    <GreenAmbassadorTable users={filteredUsers} toast={toast} />

                    {/* Pagination Controls */}
                    {pagination && pagination.totalPages > 1 && (
                        <div className="flex items-center justify-between py-4 px-6 border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Showing page <span className="font-semibold">{pagination.currentPage}</span> of{' '}
                                <span className="font-semibold">{pagination.totalPages}</span> ({pagination.totalCount} total ambassadors)
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => { setCurrentPage(currentPage - 1); setSearchFilters({...activeFiltersObject, page: currentPage - 1}); }}
                                    disabled={!pagination.hasPrevPage}
                                    className={`px-4 py-2 text-sm font-medium rounded-md ${
                                        pagination.hasPrevPage
                                            ? 'bg-primary text-white hover:bg-green-600'
                                            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className="px-4 py-2 text-sm font-medium">
                                    Page {pagination.currentPage} / {pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => { setCurrentPage(currentPage + 1); setSearchFilters({...activeFiltersObject, page: currentPage + 1}); }}
                                    disabled={!pagination.hasNextPage}
                                    className={`px-4 py-2 text-sm font-medium rounded-md ${
                                        pagination.hasNextPage
                                            ? 'bg-primary text-white hover:bg-green-600'
                                            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                    }`}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
            <ToastContainer
                position="top-right"
                autoClose={1000}
            />
        </main>
    );
}

export default UserAmbassadorList;